import { TFile, TFileUpload } from "@/types";

export const initialFileTypeObj: (
  payload: TFile,
  fileUrl?: string
) => TFileUpload = (payload, fileUrl) => ({
  file: payload,
  fileName: payload?.name,
  signedUrl: fileUrl,
});
